module.exports = __webpack_public_path__ + "static/img/14000010.1e410190.png";